<script>
  import { createEventDispatcher } from "svelte";
  let dispatch = createEventDispatcher();
  export let club;
</script>


<div class="box">
  <br/>
  <br/>
  <!-- svelte-ignore a11y-no-onchange -->
  <select id="club" name="club" bind:value={club} on:change={() => dispatch('selectChange', club)}>
    <option value="" disabled selected hidden>Select a Club...</option>
    <option value="Broadwell">Broadwell Amateurs</option>
    <option value="Bromley">Bromley Heath United</option>
    <option value="English">English Bicknor</option>
    <option value="Frampton">Frampton United</option>
    <option value="Gala">Gala Wilton</option>
    <option value="Hanham">Hanham Athletic</option>
    <option value="Hardwicke">Hardwicke</option>
    <option value="Henbury">Henbury</option>
    <option value="Little">Little Stoke</option>
    <option value="Patchway">Patchway Town</option>
    <option value="Quedgeley">Quedgeley Wanderers</option>
    <option value="Rockleaze">Rockleaze Rangers</option>
    <option value="Ruardean">Ruardean Hill Rangers</option>
    <option value="Sharpness">Sharpness</option>
    <option value="Shirehampton">Shirehampton</option>
    <option value="Wick">Wick</option>
  </select>
 
</div>


<style>

div {
    width:90%;
}

.box {
    margin: auto;
    padding-bottom: 2px;
    text-align: center;
   
}
#club {

    margin: .5em .2em auto auto;
    font-size: 2em; 
    border-radius: 1em;
    border-color: slategrey; 
    color: royalblue;
    font-weight: 600;
    box-shadow: 2px 2px black;
    background-color: whitesmoke;
}


/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {



    #club {
        width:auto;
        margin-top: 1em 1em auto auto;
    }
}
</style>
